import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { ContactTypeList } from "../contactType/ContactTypeList";

export const ContactTypePage: FC = () => {
	return (
		<Routes>
			<Route index element={<ContactTypeList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
